import { FC, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { ScenarioCapTableByShareClassStakeholder } from '../../../../../types/scenario-modeling.types';
import { CapTableTab, Column, ShareClassColumns } from '../fundraising.types';
import { TableRow } from '../table-components/index';

export type ShareClassTableItemProps = {
  className?: string;
  fields: Record<
    ShareClassColumns,
    { change: null | number | string; value: number | number[] | string | string[] } | null
  >;
  isModified?: boolean;
  items?: ScenarioCapTableByShareClassStakeholder[];
  visibleColumns: Column[];
};

export const ShareClassTableItem: FC<ShareClassTableItemProps> = ({
  fields,
  visibleColumns,
  className,
  items = [],
  isModified = false,
}) => {
  const [isExpanded, setExpanded] = useState(false);
  const isItemsEmpty = items.length === 0;

  return (
    <>
      <TableRow
        fields={fields}
        handleExpandRow={setExpanded}
        isExpanded={isExpanded}
        isExpandedRow={isItemsEmpty}
        tab={CapTableTab.BY_SHARE_CLASS}
        tdClassName={className}
        trClassName={twMerge(isExpanded && 'bg-brand-25')}
        visibleColumns={visibleColumns}
      />
      {isExpanded && (
        <>
          {items.map(
            (
              {
                avgSharePrice,
                convertedBasis,
                convertedBasisPercentage,
                diluted,
                dilutedPercentage,
                investment,
                issued,
                issuedPercentage,
                votingPercentage,
                name,
                avgSharePriceChange,
                convertedBasisChange,
                convertedBasisPercentageChange,
                dilutedChange,
                dilutedPercentageChange,
                investmentChange,
                issuedChange,
                issuedPercentageChange,
                voting,
                votingChange,
                votingPercentageChange,
              },
              i,
            ) => {
              return (
                <TableRow
                  className="bg-[#F9FAFB] shadow-[inset_2px_0px_0px_0px_#2565C8]"
                  fields={{
                    [Column.NAME]: { value: name, change: null },
                    [Column.NO_OF_STAKEHOLDERS]: { value: '-', change: null },
                    [Column.ISSUED]: {
                      change: issuedPercentageChange,
                      value: issuedPercentage * 100,
                    },
                    [Column.DILUTED]: {
                      value: dilutedPercentage * 100,
                      change: dilutedPercentageChange,
                    },
                    [Column.VOTING]: {
                      value: votingPercentage * 100,
                      change: votingPercentageChange,
                    },
                    [Column.CONVERTED_PERCENTAGE]: {
                      value: convertedBasisPercentage * 100,
                      change: convertedBasisPercentageChange,
                    },
                    [Column.NO_ISSUED]: {
                      change: issuedChange,
                      value: issued,
                    },
                    [Column.DILUTED_SHARES]: {
                      change: dilutedChange,
                      value: diluted,
                    },

                    [Column.VOTING_RIGHTS]: {
                      change: votingChange,
                      value: voting,
                    },
                    [Column.INVESTMENT]: {
                      change: investmentChange,
                      value: investment,
                    },
                    [Column.AVERAGE_SHARE_PRICE]: {
                      change: avgSharePriceChange,
                      value: avgSharePrice,
                    },
                    [Column.CONVERTED_SHARES]: {
                      change: convertedBasisChange,
                      value: convertedBasis,
                    },
                  }}
                  isExpandedRow={true}
                  key={`${i}_${name}`}
                  showToolTip={isModified}
                  tab={CapTableTab.BY_SHARE_CLASS}
                  trClassName="bg-brand-25"
                  visibleColumns={visibleColumns}
                />
              );
            },
          )}
        </>
      )}
    </>
  );
};
